export default __webpack_public_path__ + "static/soehne-web-buch-kursiv-1564f60d6d19b353982b37f562c0563c.eot";